'use client';

import Link from "next/link";
import { Pencil } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function PageEditButton({
                                           pageId,
                                          }: {
    pageId: number;
}) {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) return null;
    if (!isAuthenticated) return null;

    return (
        <Link
            href={`${process.env.NEXT_PUBLIC_URL_DASHBOARD}/pages/${pageId}`}
            target="_blank"
            title="ویرایش صفحه"
            className="inline-flex z-10 items-center justify-center bg-black hover:bg-gray-600 p-2.5 text-sm font-bold text-white absolute top-2 left-2 lg:-left-10 rounded-lg lg:rounded-none lg:rounded-l-lg"
        >
            <Pencil className="text-white w-5 h-5" />
        </Link>
    );
}